module.exports = __webpack_public_path__ + "img/sr1.5ef51405.png";